const types = {
    SET_GROUPS: '[CASHIER MOBILE] SET GROUPS',
    SET_DAYLI: '[CASHIER MOBILE] SET LIST',
    SET_SHIFT: '[CASHIER MOBILE] SET SHIFT',
    SET_GROUPS_VIEW: '[CASHIER MOBILE] SET GROUPS VIEW',
    SET_COUNT_GAMER: '[CASHIER MOBILE] COUNT GAMER',
    SET_OPERATOR_DETALIZATION: '[CASHIER] OPERATOR DETALIZATION',
    SET_BET: '[CASHIER] SET BET',
}

export {
    types,
}